import { atom } from "jotai";
import * as z from "zod";

import { BuiltInApp, Table } from "../types";
import { atomWithRefresh, extractErrorMessageFromResponse } from "../utils";
import { getSubpathBridgeClientFetch } from "@zapier/identity/client/fetch";
import { listTablesResponseSchema } from "./schemas/tablesApiSchemas";

const tablesClient = getSubpathBridgeClientFetch("tables");

export const tablesAppAtom = atom<BuiltInApp | null>(null);
tablesAppAtom.debugLabel = "tablesAppAtom";

export const tablesAtom_SUSPENDS = atomWithRefresh<Promise<Table[]>>(
  async () => {
    try {
      const res: unknown = await tablesClient(`/v1/tables`);

      if (!(res instanceof Response)) {
        console.error(`Unknown response type from bridge client for tables`);
        return [];
      }

      if (res.ok) {
        const json: unknown = await res.json();
        return listTablesResponseSchema.parse(json).data;
      } else {
        /* ----- 5xx or other unexpected errors – log & degrade ----- */
        const errorMessage = await extractErrorMessageFromResponse(res);
        console.error(`Failed to fetch tables: ${errorMessage}`);
        return [];
      }
    } catch (error) {
      if (error instanceof z.ZodError) {
        const prettyError = z.prettifyError(error);
        console.error(`Tables API response validation failed:`, prettyError);
      } else {
        console.error(`Error fetching tables:`, error);
      }

      return [];
    }
  },
);

tablesAtom_SUSPENDS.debugLabel = "tablesAtom_SUSPENDS";
